import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/Auth";
import {
  CallIcon,
  CallIcon2,
  PhoneIcon,
  PhoneIcon2,
  WAIcon,
  WAIconDark,
  ActiveStatusIcon,
  Disabled,
  Rejected,
  Pending,
  Update,
  NewNoBg,
} from "../../icons/Icon";
import styles from "./DealerStyles.module.css";
import { AllCount, DeletedBin, VerifiedTick } from "../../icons/Icon2";

const DealerInfoCard = ({
  dealerName,
  dealerStatus,
  dealerDesignation,
  dealerLocation,
  type,
  imageUri,
  whatappNo,
}) => {
  const { mode, designation } = useAuth();
  const navigate = useNavigate();
  const renderStatusIcon = () => {
    switch (dealerStatus) {
      case "disable":
      case "Blacklisted":
        return <Disabled />;
      case "New":
        return <NewNoBg />;
      case "Pending":
        return <Pending />;
      case "Rejected":
        return <Rejected />;
      case "All":
        return <AllCount />;
      case "Verified":
        return <VerifiedTick />;
      case "active":
        return <ActiveStatusIcon />;
      case "Update":
        return <Update />;
      case "Deleted":
        return <DeletedBin />;
      default:
        return null;
    }
  };
  return (
    <div
      className={
        mode
          ? `${styles.dealer_Info_Card} ${styles.dealer_Info_Card_Dark}`
          : styles.dealer_Info_Card
      }
      onClick={() => {
        if (type !== "manager") {
          if (designation === "superadmin") {
            navigate("/dealers/" + whatappNo);
          }
        }
      }}
    >
      <div className={styles.mob_style_1}>
        <div className={styles.dealer_img}>
          {imageUri ? (
            <img src={`${process.env.REACT_APP_S3URL}${imageUri}`} alt={type} />
          ) : (
            <div className={styles.Frist_text}>
              {dealerName.charAt(0).toUpperCase()}
            </div>
          )}
          <div className={styles.dealer_status_icon}>{renderStatusIcon()}</div>
        </div>

        <div>
          <div className={styles.dealer_Info_Card_name}>
            <p style={mode ? { color: "#fff" } : {}}>{dealerName}</p>
          </div>

          <div className={styles.dealer_Info_Card_Text_Section}>
            <p style={mode ? { color: "#fff" } : {}}>{dealerDesignation}</p>
            <p
              style={{
                color: mode ? "#fff" : "",
                display: type === "manager" ? "none" : "block",
              }}
            >
              {dealerLocation}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.dealer_Info_Card_Icons_Tray}>
        {mode ? (
          <>
            <PhoneIcon2 />
            <CallIcon2 />
            <WAIconDark />
          </>
        ) : (
          <>
            <PhoneIcon />
            <CallIcon />
            <WAIcon />
          </>
        )}
      </div>
    </div>
  );
};

export default DealerInfoCard;
